module.exports = __webpack_public_path__ + "static/img/2-3.31eb5d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/2-3.png
// module id = 1dse
// module chunks = 0